import axios from 'axios';

export const getProductById = (productId) => {
  return axios.get(
    `/api/merchants/${window.mainConfig.merchantId}/products/${productId}`,
  );
};

/**
 * Fetch multiple products in batch.
 *
 * @see https://shopline.atlassian.net/wiki/spaces/EN/pages/5036179469/X+Y
 *
 * @param {Object} params
 * @param {string[]} params.product_ids
 * @param {Array<'spu_option'|'sku_option'|'agg'|'sku'|'stock'|'lowest_member_price'>} params.include_modules
 * @param {string} params.target_channel_id
 * @param {'checkout'|'promotion'} params.req_source
 */
export const getProductByIds = (params) => {
  return axios.post(`/api/products/list_products`, params);
};

export const checkProductStock = (productId, variationId, onePageStoreId) => {
  const params = {};
  if (variationId) {
    params.variation_id = variationId;
  }
  if (onePageStoreId) {
    params.one_page_store_id = onePageStoreId;
  }
  const queryParams = new URLSearchParams(params);
  return axios.get(
    `/api/merchants/${window.mainConfig.merchantId}/products/${productId}/check_stock?${queryParams.toString()}`,
  );
};

/**
 * @param {*} productId product set id
 * @param {*} selected child product selected info,
 *   data example: { child_product_id: { selectedNum: 3, selectedVariationsNum: { variationId1: 1, variationId2: 1 } } }
 * @returns
 */
export const checkProductSetStock = (productId, selected, onePageStoreId) => {
  const querySearch = [];
  Object.values(selected).forEach((childSelected) => {
    const { selectedNum, selectedVariationsNum } = childSelected;
    if (!selectedNum) {
      return;
    }
    const vantionsSelectedList = Object.entries(selectedVariationsNum || {});
    if (vantionsSelectedList.length > 0) {
      vantionsSelectedList.forEach(([vantionKey, vantionQuantity]) => {
        querySearch.push(
          [
            `selected_child_products[][child_product_id]=${childSelected.id}`,
            `selected_child_products[][child_variation_id]=${vantionKey}`,
            `selected_child_products[][quantity]=${vantionQuantity}`,
          ].join('&&'),
        );
      });
    } else {
      querySearch.push(
        [
          `selected_child_products[][child_product_id]=${childSelected.id}`,
          `selected_child_products[][quantity]=${selectedNum}`,
        ].join('&&'),
      );
    }
  });
  if (onePageStoreId) {
    querySearch.push(`one_page_store_id=${onePageStoreId}`);
  }
  return axios.get(
    `/api/merchants/${window.mainConfig.merchantId}/products/${
      productId
    }/check_stock?${querySearch.join('&')}`,
  );
};

const productService = {
  getProduct({ id, merchantId }) {
    return axios.get(`/api/merchants/${merchantId}/products/${id}`);
  },
  checkStocks({ products, channelId, merchantId }) {
    const params = { products, target_channel_id: channelId };
    return axios.post(
      `/api/merchants/${merchantId}/products/check_stocks/`,
      params,
    );
  },
};

export default productService;
